// Search Function
var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }

        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

// Currency Change
function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


  // Sliders

   // Full Width Slider Section

   var announcementSlider = new Swiper (".announcement-bar-slider", {
    loop: true,
    pagination: false,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-announcement-next",
      prevEl: ".swiper-announcement-prev",
    },
  });

  // Full Width Slider Section

  var swiper = new Swiper (".full-width-slider", {
    lazy: true,
    loop: true,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Featured Quotes Slider Section
  
  var slider = new Swiper ('.featured-quotes-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    effect: 'fade',
    loopedSlides: 5,
});

var thumbs = new Swiper ('.featured-quotes-thumbs', {
    slidesPerView: '2',
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    slideToClickedSlide: true,
    breakpoints: {
        280: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
});

slider.controller.control = thumbs;
thumbs.controller.control = slider

// Featured Quotes Slider Mobile 
  
let featuredQuotesMob = new Swiper(".featured-quotes-mobile", {
  slidesPerView: 2,
  spaceBetween: 0,
  loop: true,
  autoplay:true,
  autoHeight: true,
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
  },
});

  // Marquee Slider Section

  let SwiperTop = new Swiper('.swiper--marquee', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 20000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true,
  });

    // Marquee Image Slider Section

    let SwiperTopImages = new Swiper('.swiper--marquee--image', {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 20000,
      autoplay: {
        delay: 1,
      },
      loop: true,
      slidesPerView:'5',
      allowTouchMove: true,
      disableOnInteraction: false,
      paginationClickable: true,
      slideToClickedSlide: true,
      breakpoints: {
        200: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 2,
        },
        769: {
          slidesPerView: 3,
        },
        1034: {
          slidesPerView: 5,
        },
      },
    });


  // Testimonials Slider Section

let swiperTestimonials = new Swiper(".testimonials--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  autoHeight: true,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    769: {
      slidesPerView: 3,
    },
  },
});

 // Logo List Slider Section

 let logoListTestimonials = new Swiper(".logo-list--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 3,
    },
    769: {
      slidesPerView: 5,
      spaceBetween:100,
    },
  },
});

 // Image Slider Section

 let imageTestimonials = new Swiper(".image--carousel", {
  slidesPerView: 1,
  spaceBetween: 50,
  centeredSlides: true,
  loop: true,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 2,
      spaceBetween:10,
    },
    400: {
      slidesPerView: 2,
      spaceBetween:25,
    },
    769: {
      slidesPerView: 4,
      spaceBetween:50,
    },
  },
});


// Custom for Odd


 // Custom Collection Slider Section

 let customCollection = new Swiper(".slider_custom", {
  slidesPerView: 1.2,
  spaceBetween: 0,
  loop: true,
  autoplay:true,
  authHeight: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1.2,
    },
    600: {
      slidesPerView: 3.2,
      spaceBetween:20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween:100,
    },
  },
});



 // Custom Colour Cards Slider Section

 let customCards = new Swiper(".slider_cards", {
  slidesPerView: 1.2,
  spaceBetween: 0,
  loop: true,
  autoplay:true,
  authHeight: true,
  breakpoints: {
    200: {
      slidesPerView: 1.2,
      spaceBetween:10,
    },
    600: {
      slidesPerView: 2.2,
      spaceBetween:20,
    },
    768: {
      slidesPerView: 3.2,
      spaceBetween:20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween:100,
    },
  },
});


// Anchor Link Scroll

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});


// Partners Slider

var swiper = new Swiper('.swiper--partners', {
  pagination: '.swiper-pagination',
  slidesPerView: 7,
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  spaceBetween: 30,
  slideToClickedSlide: true,
  breakpoints: {
    200: {
      slidesPerView: 2,
      spaceBetween:10,
    },
    600: {
      slidesPerView: 4,
      spaceBetween:20,      
    },
    1024: {
      slidesPerView: 7,
      spaceBetween:30,
    },
  },
});


// Instagram Slider

var swiper = new Swiper('.swiper--insta', {
  pagination: '.swiper-pagination',
  slidesPerView: 6,
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  spaceBetween: 30,
  slideToClickedSlide: true,
  breakpoints: {
    200: {
      slidesPerView: 2,
      spaceBetween:10,
    },
    600: {
      slidesPerView: 4,
      spaceBetween:20,      
    },
    1024: {
      slidesPerView: 6,
      spaceBetween:30,
    },
  },
});




// IMage Carousel Section

var swiperFour = new Swiper('.swiper--four', {
  pagination: '.swiper-pagination',
  slidesPerView: 6,
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  spaceBetween: 30,
  slideToClickedSlide: true,
  breakpoints: {
    200: {
      slidesPerView: 2,
      spaceBetween:10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween:20,      
    },
    1024: {
      slidesPerView: 4,
      spaceBetween:25,
    },
  },
});



// Nav BG HIde 

function navBGHide1() {
  var x = document.getElementById("megaNavBG-1");
  var y = document.getElementById("megaNavBG-2");
  var z = document.getElementById("megaNavBG-3");
  if (x.style.display === "block") {
    x.style.display = "none";
    y.style.display = "none";
    z.style.display = "none";
  } else {
    x.style.display = "block";
    y.style.display = "none";
    z.style.display = "none";
  }
}

function navBGHide2() {
  var x = document.getElementById("megaNavBG-2");
  var y = document.getElementById("megaNavBG-1");
  var z = document.getElementById("megaNavBG-3");
  if (x.style.display === "block") {
    x.style.display = "none";
    y.style.display = "none";
    z.style.display = "none";
  } else {
    x.style.display = "block";
  }
}

function navBGHide3() {
  var x = document.getElementById("megaNavBG-3");
  var y = document.getElementById("megaNavBG-2");
  var z = document.getElementById("megaNavBG-1");
  if (x.style.display === "block") {
    x.style.display = "none";
    y.style.display = "none";
    z.style.display = "none";
  } else {
    x.style.display = "block";
    y.style.display = "none";
    z.style.display = "none";
  }
} 

// Testimonials Slider

var testimonialsCustom = new Swiper('.testimonials-custom', {
  slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    200: {
      slidesPerView: 1,
      spaceBetween:10,
      slidesPerGroup: 1,
    },
    600: {
      slidesPerView: 2,  
      slidesPerGroup: 2,   
    },
    1024: {
      slidesPerView: 3,
    },
  },
});



// Mobile Header

/* Toggle between showing and hiding the navigation menu links when the user clicks on the hamburger menu / bar icon */
function myFunction() {
  var x = document.getElementById("myLinks");
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
}


 class CountUpTwo {
  constructor(triggerEl, counterEl) {
  const counter = document.querySelector(counterEl)
  const trigger = document.querySelector(triggerEl)
  let num = 0

  const countUp = () => {
    if (num <= counter.dataset.stop)
      ++num
      counter.textContent = num
  }
  
  const observer = new IntersectionObserver((el) => {
    if (el[0].isIntersecting) {
      const interval = setInterval(() => {
        (num < counter.dataset.stop) ? countUp() : clearInterval(interval)
      }, counter.dataset.speed)
    }
  }, { threshold: [0] })

  observer.observe(trigger)
  }
}

// Initialize any number of counters:
new CountUpTwo('#start1', '#counter1')
